<template>
  <section class="vbox"> 
   <section class="hbox stretch">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>核销验证</span>
        </div>
        <div>
          <el-form @submit.native.prevent :inline="true" >     
            <el-form-item >
              <el-input size="medium" ref="number" v-model="number" placeholder="请输入验证码"></el-input>
            </el-form-item>        
            <el-form-item>
              <el-button type="primary" v-on:click="Search" size="medium"  >查询</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </div>
      </el-card>    
   </section>
  </section>
</template>

<script  type='text/ecmascript-6'>
  export default {
    data (){
      return {
        number:'',
        activeName:'0',
        member:{}
      }
    },
    components:{
    },
    computed:{
    },
    mounted(){
    },
    methods:{  
      handleClick(tab, event) {
        console.log(tab, event);
      },   
      Search:function(){
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Member/get',
          params:{
            
          }
        }).then(function (resp) {

        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      SaveMember:function(){

      }

    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.box-card
  width 80%
  margin-left 10%
.left0
  margin-left 0px

</style>